import type { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';
import { authedRoute, launcherRoute, loginRoute, rootRoute } from './app/routes-base';
import { accountRoutes } from './app/account-routes';
import { backofficeTree } from './interfaces/backoffice/routes';
import { dapurTree } from './interfaces/dapur/routes';
import { gudangTree } from './interfaces/gudang/routes';
import { kasirTree } from './interfaces/kasir/routes';
import { keuanganTree } from './interfaces/keuangan/routes';
import { guestRoutes } from './interfaces/menu/routes';
import { pelayanTree } from './interfaces/pelayan/routes';
import { platformTreeWithBilling } from './interfaces/platform-billing/routes';
import { stokTree } from './interfaces/stok/routes';

export const routeTree = rootRoute.addChildren([
  loginRoute,
  ...accountRoutes,
  ...guestRoutes,
  authedRoute.addChildren([
    launcherRoute,
    kasirTree,
    pelayanTree,
    dapurTree,
    backofficeTree,
    keuanganTree,
    stokTree,
    gudangTree,
    platformTreeWithBilling, // platform console + /platform/tagihan (ADR-0033)
  ]),
]);

export function createAppRouter(queryClient: QueryClient) {
  return createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: 'intent',
    scrollRestoration: true,
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
